
































import { iosCustomUrlSchemes } from '@/models/hl-app/custom-url-scheme'
import FullscreenNotificationLayout from '@spa/hl-app/components/fullscreen-notification/FullscreenNotificationLayout.vue'
import Vue from 'vue'
import { Component } from 'vue-mixin-decorator'

@Component({
  components: {
    FullscreenNotificationLayout,
  },
})
export default class NotFound extends Vue {
  get canGoBack(): boolean {
    return window.history.length > 1
  }
  goBack(): void {
    window.history.back()
  }
  closePage(): void {
    location.href = iosCustomUrlSchemes.close
  }
}
